import React from "react";

import { Routes, Route } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import Dashboard from './components/Dashboard';
import RSVPApproval from './components/RSVPApproval';
import AdminSetupPage from "./pages/AdminSetupPage"; 
import LandingPage from "./pages/LandingPage"; 
import Homepage from "./pages/Homepage"; 
import './App.css';
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/home" element={<Homepage />} />
      <Route path="/login" element={<LoginForm />} />
      <Route path="/register" element={<RegisterForm />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/RSVPApproval/:id" element={<RSVPApproval />} />
      <Route path="/admin-setup" element={<AdminSetupPage />} />
    </Routes>
  );
};

export default App;

